import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Card, Button, Divider, message, Modal, Input, Form, Alert, Select } from "antd";
import { FileDoneOutlined } from "@ant-design/icons";
import { HeaderPage } from "../../components/headerPage";
import { HeaderTitle } from "../../components/headerTitle";
import { AuthContext } from "../../contexts/AuthContext";
import http from "../../services/http";
import InputMask from "../../components/inputMask";
import { SelectItem } from "../../components/selectItem";

export const AtualizarCadastro = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState();
  const [etnias, setEtnias] = useState([]);
  const { session, atualizarUsuario, encerrarSessao } = useContext(AuthContext);

  useEffect(() => {
    getEtnias();
    form.setFieldsValue({
      nome: session?.usuario?.nome,
      matricula: session?.usuario?.matricula,
      celular: session?.usuario?.celular,
      email: session?.usuario?.email,
      id_cad_etnias: session?.usuario?.id_cad_etnias,
      status_dois_fatores: session?.usuario?.status_dois_fatores === 1 ? true : false,
    });
  }, []);

  const getEtnias = async () => {
    setLoading(true);
    try {
      const api = await http("get", "v1/etnias/getAll");
      if (api.statusCode === 200) {
        let array_etnias = [];
        for (let el of api?.response?.data ?? []) {
          array_etnias.push({ value: el.id, label: el.descricao });
        }
        setEtnias(array_etnias);
      } else {
        message.error(api.response.message);
      }
    } catch (error) {
      message.error("Ops, houve um erro!");
    } finally {
      setLoading(false);
    }
  };

  const realizarLogout = async () => {
    await http("get", "v1/autenticacao/logout", []);
    message.success("Logout realizado com sucesso!");
    await encerrarSessao();
  };

  const autalizarContatos = async (formData) => {
    setLoading(true);
    formData.status_dois_fatores = formData?.status_dois_fatores === true ? 1 : 0;
    const api = await http("post", "v1/usuario/atualizar_cadastro", formData);
    if (api.statusCode === 200) {
      atualizarUsuario(api.response.data.user);
      message.success("Dados atualizados com sucesso!");
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  return (
    <Row align="middle" justify="center" className="content-row">
      <Col xs={24} sm={24} md={22} lg={20} xl={20} xxl={14} align="left" className="content-item">
        <HeaderPage backText="Sair" title="Configurações" onClickBack={realizarLogout} />
        <HeaderTitle
          title="Atualização Cadastral"
          subtitle="Atualização obrigatória das suas informações"
          icon={<FileDoneOutlined />}
          loading={loading}
        />
        <Divider />

        <Card bordered={false} bodyStyle={{ padding: "3%" }}>
          <Form form={form} onFinish={autalizarContatos} layout="vertical" autoComplete="off">
            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
              <Col className="gutter-row" span={24} style={{ marginBottom: 20 }}>
                <Alert
                  showIcon
                  message="Atualize as suas informações cadastrais para continuar a utilizar o sistema!"
                  type="info"
                />
              </Col>

              <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item name="nome" label="Nome" rules={[{ required: true, message: "Digite o nome!" }]}>
                  <Input size="large" className="read-only" disabled={true} placeholder="Informe o nome" />
                </Form.Item>
              </Col>

              <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  name="matricula"
                  label="Matrícula"
                  rules={[{ required: true, message: "Digite a matrícula!" }]}>
                  <Input size="large" className="read-only" disabled={true} placeholder="Informe a matrícula" />
                </Form.Item>
              </Col>

              <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item name="celular" label="Celular">
                  <InputMask mask="(99) 9 9999-9999" size="large" disabled={loading} placeholder="Informe o celular" />
                </Form.Item>
              </Col>

              <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  label="E-mail"
                  name="email"
                  rules={[{ required: false, message: "Informe um e-mail válido", type: "email" }]}>
                  <Input
                    className="input"
                    autoComplete="off"
                    size="large"
                    disabled={loading}
                    placeholder="Digite seu Email"
                  />
                </Form.Item>
              </Col>

              <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  name="id_cad_etnias"
                  label="Etnia"
                  rules={[{ required: true, message: "Selecione a etnia!" }]}>
                  <Select
                    allowClear
                    placeholder="Selecione a etnia"
                    size="large"
                    style={{ width: "100%" }}
                    options={etnias}
                    disabled={loading}
                  />
                </Form.Item>
              </Col>

              <Col className="gutter-row" span={24}>
                <Form.Item name="status_dois_fatores" valuePropName="checked">
                  <SelectItem
                    disabled={loading}
                    title="Autenticação Dois Fatores"
                    text="Habilitar ou desabilitar autenticação dois fatores"
                  />
                </Form.Item>
              </Col>

              <Col className="gutter-row" span={24}>
                <Button disabled={loading} size="large" type="primary" htmlType="submit">
                  Salvar
                </Button>
              </Col>
            </Row>
          </Form>
        </Card>
      </Col>
    </Row>
  );
};
